import type { UserbackWidget } from "@userback/widget";

let userbackInstance: UserbackWidget | null = null;

export function setUserbackInstance(instance: UserbackWidget) {
  userbackInstance = instance;
}

export function getUserbackInstance(): UserbackWidget | null {
  return userbackInstance;
}

export function useUserback() {
  return {
    open: () => userbackInstance?.open(),
    openForm: (...args: Parameters<UserbackWidget["openForm"]>) =>
      userbackInstance?.openForm(...args),
    identify: (...args: Parameters<UserbackWidget["identify"]>) =>
      userbackInstance?.identify(...args),
    isLoaded: () => userbackInstance?.isLoaded() ?? false,
  };
}
